'use client';

import { c as _c } from "react/compiler-runtime";
import { DateInput, DateSegment, type DateValue, Label, TimeField, type TimeValue } from 'react-aria-components';
import styles from './time-picker.module.scss';
type TimePickerProps = {
  isDisabled?: boolean;
  label?: string;
  onChange?: (value: DateValue | null) => void;
  value?: DateValue | null;
};
export const TimePicker = t0 => {
  const $ = _c(15);
  const {
    isDisabled: t1,
    label: t2,
    onChange,
    value
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const label = t2 === undefined ? "Time" : t2;
  let t3;
  if ($[0] !== isDisabled || $[1] !== onChange || $[2] !== value) {
    t3 = time => {
      if (isDisabled || !value || !time || !("set" in value)) {
        return;
      }
      const updated = value.set({
        hour: time.hour
      });
      onChange?.(updated);
    };
    $[0] = isDisabled;
    $[1] = onChange;
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleTimeChange = t3;
  let t4;
  if ($[4] !== label) {
    t4 = <Label className={styles["time-picker__time-field-label"]}>{label}</Label>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = value as null | TimeValue;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DateInput className={styles["time-picker__time-field-input"]}>{_temp}</DateInput>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== handleTimeChange || $[8] !== isDisabled || $[9] !== label || $[10] !== t5) {
    t7 = <TimeField aria-label={label} granularity="hour" hideTimeZone={true} isDisabled={isDisabled} onChange={handleTimeChange} value={t5}>{t6}</TimeField>;
    $[7] = handleTimeChange;
    $[8] = isDisabled;
    $[9] = label;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className={styles["time-picker__time-field"]}>{t4}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(segment) {
  return <DateSegment segment={segment} />;
}